var _style, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBlueprintjs(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 1000 1000",
    style: {
      enableBackground: "new 0 0 1000 1000"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#11B470;}\n\t.st1{fill:#2F94D1;}\n\t.st2{fill:#F15853;}\n\t.st3{fill:#34B1E6;}\n\t.st4{fill:#00AB64;}\n\t.st5{fill:#43BA89;}\n\t.st6{fill:#3CB981;}\n\t.st7{fill:#35ADE3;}\n\t.st8{fill:#F3716D;}\n\t.st9{fill:#2D8DCC;}\n\t.st10{fill:#F04945;}\n\t.st11{fill:#F16561;}\n\t.st12{fill:#B72025;}\n\t.st13{fill:#B22024;}\n\t.st14{fill:#12181B;fill-opacity:0.2;}\n\t.st15{fill:#05733B;}\n\t.st16{fill:#086936;}\n\t.st17{fill:#255DAB;}\n\t.st18{fill:#2962AE;}\n\t.st19{opacity:0.78;fill:#F9BCB8;enable-background:new    ;}\n\t.st20{opacity:0.78;fill:#68CCE9;enable-background:new    ;}\n\t.st21{opacity:0.78;fill:#68C6B4;enable-background:new    ;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "704.1,384.6 906.7,504.4 906.7,741.1 704.1,857.9 500,741.1 500,504.4  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "500,26.7 704.1,148 704.1,384.6 500,500 295.9,384.6 295.9,148  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "704.1,148 906.7,267.8 906.7,504.4 704.1,621.3 500,504.4 500,267.8  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "295.9,148 500,267.8 500,504.4 295.9,621.3 93.3,504.4 93.3,267.8  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "295.9,384.6 500,504.4 500,741.1 295.9,857.9 93.3,741.1 93.3,504.4  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "500,500 704.1,621.3 704.1,857.9 500,973.3 295.9,857.9 295.9,621.3  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M704.1,148L500,267.8L295.9,148L500,26.7L704.1,148z M906.7,267.8L702.6,389.1L500,267.8l204.1-121.3 L906.7,267.8L906.7,267.8z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "500,736.6 500,500 295.9,621.3 295.9,857.9  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "704.1,621.3 500,736.6 295.9,621.3 500,500  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st6",
    points: "500,736.6 295.9,621.3 500,500  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st7",
    points: "500,267.8 295.9,148 500,26.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st8",
    points: "500,267.8 295.9,389.1 93.3,267.8 295.9,148  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st9",
    points: "906.7,504.4 704.1,621.3 500,500 704.1,389.1  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st10",
    points: "292.9,855 93.3,739.6 292.9,618.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st11",
    points: "295.9,389.1 295.9,148 500,267.8 500,500  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st12",
    points: "500,500 500,267.8 295.9,389.1 295.9,621.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st13",
    points: "500,500 295.9,389.1 500,267.8  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st14",
    points: "906.7,741.1 704.1,621.3 906.7,504.4  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M704.1,857.9V621.3L500,736.6v236.6L704.1,857.9L704.1,857.9z M906.7,741.1V504.4L702.6,619.8v236.6 L906.7,741.1z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st16",
    points: "906.7,741.1 704.1,621.3 906.7,504.4  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st17",
    points: "906.7,504.4 906.7,267.8 704.1,389.1 704.1,621.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st18",
    points: "906.7,504.4 704.1,389.1 906.7,267.8  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M93.3,267.8l204.1,115.4L500,267.8L301.8,390.6l-4.4,229.2l0,0l-4.4-229.2L93.3,267.8z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st20",
    points: "500,267.8 704.1,384.6 906.7,267.8 708.5,390.6 704.1,621.3 698.2,390.6  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st21",
    d: "M295.9,621.3L500,732.2l204.1-110.9L505.9,739.6L500,973.3l0,0l-4.4-233.7L295.9,621.3L295.9,621.3z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlueprintjs);
export default __webpack_public_path__ + "static/media/blueprintjs.08a266ba7bbe7b8d813d2a9a9fd568ca.svg";
export { ForwardRef as ReactComponent };